import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type RecordManualJobCostMutationVariables = Types.Exact<{
  jobId: Types.Scalars['String']['input'];
  costCategory: Types.CostCategory;
  amount: Types.Scalars['Decimal']['input'];
  description: Types.Scalars['String']['input'];
  recordId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  subcategory?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type RecordManualJobCostMutation = { __typename?: 'Mutation', recordManualJobCost: { __typename?: 'JobCostPayload', jobCostRecord?: { __typename?: 'JobCostRecordDocument', recordId: string, jobId: string, costCategory: Types.CostCategory, amount: number, unitCost?: number | null, quantity?: number | null, unit?: string | null, sourceType: Types.CostSourceType, subcategory?: string | null, description?: string | null, recordedDate: Types.TDateISO, isEstimated: boolean, isReversal: boolean } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ReverseManualJobCostMutationVariables = Types.Exact<{
  jobId: Types.Scalars['String']['input'];
  recordId: Types.Scalars['String']['input'];
}>;


export type ReverseManualJobCostMutation = { __typename?: 'Mutation', reverseManualJobCost: { __typename?: 'JobCostPayload', jobCostRecord?: { __typename?: 'JobCostRecordDocument', recordId: string, jobId: string, costCategory: Types.CostCategory, amount: number, unitCost?: number | null, quantity?: number | null, unit?: string | null, sourceType: Types.CostSourceType, subcategory?: string | null, description?: string | null, recordedDate: Types.TDateISO, isEstimated: boolean, isReversal: boolean } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const RecordManualJobCostDocument = new TypedDocumentString(`
    mutation RecordManualJobCost($jobId: String!, $costCategory: CostCategory!, $amount: Decimal!, $description: String!, $recordId: String, $subcategory: String) {
  recordManualJobCost(
    jobId: $jobId
    costCategory: $costCategory
    amount: $amount
    description: $description
    recordId: $recordId
    subcategory: $subcategory
  ) {
    jobCostRecord {
      ...JobCostRecordFields
    }
    errors {
      code
      message
    }
  }
}
    fragment JobCostRecordFields on JobCostRecordDocument {
  recordId
  jobId
  costCategory
  amount
  unitCost
  quantity
  unit
  sourceType
  subcategory
  description
  recordedDate
  isEstimated
  isReversal
}`);
export const ReverseManualJobCostDocument = new TypedDocumentString(`
    mutation ReverseManualJobCost($jobId: String!, $recordId: String!) {
  reverseManualJobCost(jobId: $jobId, recordId: $recordId) {
    jobCostRecord {
      ...JobCostRecordFields
    }
    errors {
      code
      message
    }
  }
}
    fragment JobCostRecordFields on JobCostRecordDocument {
  recordId
  jobId
  costCategory
  amount
  unitCost
  quantity
  unit
  sourceType
  subcategory
  description
  recordedDate
  isEstimated
  isReversal
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    RecordManualJobCost: build.mutation<RecordManualJobCostMutation, RecordManualJobCostMutationVariables>({
      query: (variables) => ({ document: RecordManualJobCostDocument, variables })
    }),
    ReverseManualJobCost: build.mutation<ReverseManualJobCostMutation, ReverseManualJobCostMutationVariables>({
      query: (variables) => ({ document: ReverseManualJobCostDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useRecordManualJobCostMutation, useReverseManualJobCostMutation } = injectedRtkApi;
